<div class="content-blk">
  <div class="container">
    <h5 class="page-title">
      Warehouse Products
      <small class="pull-right title-link">
        <a [routerLink]="['/store/addcustomproduct']">Add Products</a>
      </small>
      <span class="clearfix"></span>
    </h5>
    <div class="white-background">
      <form class="example-form  pull-right" [formGroup]="searchCommission">
        <div class="srch-flt-rt">
          <mat-form-field floatLabel="never">
            <input matInput placeholder="Search" formControlName="search" ng-model-options="{debounce: 10000}"
                   (change)="fn_searchCommission(searchCommission)">
          </mat-form-field>
        </div>
      </form>
      <div class="search-results" infiniteScroll [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
             (scrolled)="fn_getCustomProductList_Scroll()" [infiniteScrollDisabled]="isFullListDisplayed">
        <div class="sp-admin-list-tbl pro-tble-outer cmsn-list cmsn-bx-ut">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Product</th>
                  <th *ngIf="!IsStoreAdmin">Client</th>
                  <th>Categories</th>
                  <th>Price</th>
                  <th>Created On</th>
                  <th>Status</th>
                  <th>Comments</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="isDisplay">
                  <td colspan="9" class="text-center">
                    No record(s) available
                  </td>
                </tr>
                <tr *ngFor="let item of customproductList; let i=index">
                  <td>{{i + 1}} </td>
                  <td style="text-transform:capitalize">
                    <div class="product-wh-img-div">
                      <span *ngIf="item.ProductImages.length > 1" (click)="fn_viewProductdetais(item.ProductID)" title="+ {{item.ProductImages.length -1}} Images">+ {{item.ProductImages.length -1}}</span>
                      <img height="50" [src]="fn_GetImage(item.ProductImages[0])" class="product-wh-img" /><sup class="text-danger" *ngIf="item.DesignId>0">**Bulk Order</sup>
                      <br />
                      <strong>{{item.Title}}</strong>
                    </div>
                  </td>
                  <td *ngIf="!IsStoreAdmin">
                    {{item.UserName}}
                  </td>
                  <td>
                    <span *ngFor="let cat of item.Categories;let c=index">
                      <span class="text-muted">
                        <i class="fa fa-plus expand" (click)="showIndex=c.toString() + i.toString()"
                           *ngIf="showIndex!=c.toString() + i.toString() && cat.SubCatetgoryList.length > 0" aria-hidden="true"></i>
                        <i (click)="showIndex=null" *ngIf="showIndex==c.toString() + i.toString()  && cat.SubCatetgoryList.length > 0"
                           class="fa fa-minus collapsed" aria-hidden="true"></i>
                        <i class="empty" *ngIf="cat.SubCatetgoryList.length == 0"></i>
                        {{cat.CategoryName}}
                      </span><br />
                      <span *ngIf="showIndex==c.toString() + i.toString()">
                        <span *ngFor="let subCat of cat.SubCatetgoryList;let sc=index">
                          &nbsp;
                          <i class="fa fa-level-up collapsed-result" aria-hidden="true"></i>
                          &nbsp;
                          {{subCat.SubCategoryName}}<br />
                        </span>
                      </span>
                    </span>
                  </td>
                  <td>{{item.RetailPrice| currency:'USD':'symbol':'1.2-4'}}</td>
                  <td>{{item.CreatedDate | date }}</td>
                  <td>
                    <span class="text-info" *ngIf="item.Status==1"><strong>New</strong></span>
                    <span class="text-success" *ngIf="item.Status==2"><strong>Approved</strong></span>
                    <span class="text-danger" *ngIf="item.Status==3"><strong>Rejected</strong></span>
                    <span class="text-warning" *ngIf="item.Status==4"><strong>ReSubmitted</strong></span>                   
                  </td>
                  <td>
                    <abbr title="{{item.Comments}}">{{item.Comments | slice:0:20}}</abbr>
                  </td>
                  <td>
                    <span (click)="fn_viewProductdetais(item.EncryptedId)" class="material-icons view-wh-details">
                      visibility
                    </span>
                    <span *ngIf="item.Status==3" (click)="fn_UpdateCustomProduct(item.EncryptedId)" class="material-icons view-wh-details" title="Edit and Resubmit Product">
                      edit <!--Status 3 is Rejected thus showing only in case of Rejected -->
                    </span>
                    <span (click)="fn_deleteCustomizedWareHouseProduct(item.ProductID)">
                      <i  style="float: left;"  class="material-icons delete-product"
                         title="Delete Design">
                        delete_outline
                      </i>
                    </span>
                    <span *ngIf="item.Status==2" (click)="fn_navigateInventoryPage(item.EncryptedId)"
                          class="material-icons view-wh-details" title="Manage Inventory">
                      format_list_numbered <!--Navigate to inventory page if it is approved-->
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <app-lazy-loader></app-lazy-loader>
        </div>
      </div>
    </div>
  </div>
</div>
